export default "__VITE_ASSET__CvY5hTZ$__"